import { create } from 'zustand';

export interface CandidateQueryWatch {
  scenarioId: string;
  country: string;
  queryId: string;
}

interface WatchState {
  watches: CandidateQueryWatch[];
  watch: (entry: CandidateQueryWatch) => void;
  unwatch: (queryId: string) => void;
}

/**
 * 끝나기를 지켜보는 조회 목록. 후보 선택 면이나 캠페인 상세 덮개가 닫혀도 남아야 하므로
 * 화면 state 가 아니라 전역 저장소에 둔다 — 지켜보는 자리(`CandidateQueryCompletionWatcher`)는
 * 앱 뿌리에 서 있다. 접수 응답을 받는 훅이 직접 담아, 응답 전에 화면을 떠나도 빠지지 않는다.
 * 같은 조회 번호는 한 번만 담긴다.
 */
export const useCandidateQueryWatchStore = create<WatchState>((set) => ({
  watches: [],
  watch: (entry) =>
    set((st) =>
      st.watches.some((w) => w.queryId === entry.queryId) ? st : { watches: [...st.watches, entry] }
    ),
  unwatch: (queryId) => set((st) => ({ watches: st.watches.filter((w) => w.queryId !== queryId) })),
}));
